{
    "CustomisePopupTitle": "Personalizar função de administrador",
    "FooterActionsSubmit": "Enviar",
    "FooterActionsCancel": "Cancelar",
    "FooterActionsHelp": "Ajuda?",
    "TableHeadingAdminAccess": "Acesso de administração",
    "HeadingAdministrate": "Administrar",
    "HeadingView": "Visão",
    "HeadingAdd": "Adicionar",
    "HeadingModify": "Mudar",
    "HeadingDelete": "Excluir",
    "EntryCme": "Gestão CME",
    "EntryDevices": "Dispositivos",
    "EntryDevicesSub": "(Extensões \/ Grupos \/ Outros Dispositivos)",
    "EntryAgents": "Agentes",
    "EntryDirectory": "Diretórios",
    "EntryApplicationUsers": "Usuários do aplicativo",
    "EntryCodes": "Códigos",
    "EntryTelServers": "Servidores de telefonia",
    "EntryPartition": "Partições",
    "EntryOmnichannel": "Omnicanal",
    "EntryRecordings": "Gravação",
    "EntryMessages": "Mensagens",
    "EntryDatabase": "Base de dados",
    "TableHeadingStatusTools": "Status e acesso a ferramentas",
    "HeadingSection": "Seção",
    "EntryLicences": "Licenças",
    "EntryLogging": "Exploração madeireira",
    "EntryLogManagement": "Gerenciamento de logs",
    "EntryAuditTrail": "Trilha de auditoria",
    "EntryTelephoneModuleStatus": "Status do Módulo de Telefone",
    "EntryOmnichannelStatus": "Status do Omnicanal",
    "EntryCallControl": "Controle de chamadas",
    "EntryServerStatus": "Status do servidor",
    "TableHeadingActions": "Ações",
    "HeadingAction": "Açao",
    "HeadingAllowed": "Permitido",
    "EntryCopyReportsTo": "Copiar relatórios para...",
    "EntrySignInAs": "Entrar como...",
    "EntryBillingFilesDownload": "CDRs de cobrança",
    "EntryBillingSummary": "Resumo do faturamento",
    "EntryChangeLicenceLevel": "Alterar nível de licença",
    "SyncPartition": "Sincronizar partição",
    "ViewChangedWarning": "Sem a opção View, {} só pode ser {} usando a API.",
    "Update": "Atualizada",
    "Delete": "deletado",
    "ViewChangeOr": "ou",
    "CustomiseRole_Add": "adicionado",
    "NAME": "CustomiseRole",
    "EntryUserRole": "Funções de utilizador",
    "EntryChangeTelephonyServerBillingStatus": "Alterar o estado de faturação do servidor de telefonia",
    "EptAccess": "Ferramenta de Provisionamento Fácil",
    "EntryLogFilesDownload": "Descarregar ficheiros de registo",
    "TelSysSyncRestrictions": "Alterar parâmetros de sincronização máxima",
    "CMEBrandingConfig": "Configuração da marca CME",
    "EntryCrm": "Gestão de CRM",
    "EntryClientConfig": "Configuração do cliente",
    "EditOwningCMEDomainProfile": "Editar perfil de domínio CME",
    "EditOwningCMEBranding": "Editar marca CME",
    "EditOwningCMEProvisioning": "Editar Provisionamento CME (Sincronização do Service Pack)",
    "EditOwnCMEDomainProfile": "Editar perfil de domínio CME próprio",
    "EditOwnCMEBranding": "Editar a própria marca CME",
    "EditOwnCMEProvisioning": "Editar Provisionamento Próprio de CME",
    "Policy": "Política"
}